import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCreatedCounter = createSelector(
  [(store: RootState) => store.massiveDocumentCreate.createdCounter],
  (data) => data
);
